module.exports = __webpack_public_path__ + "img/NewCarIcon.48392a95.svg";